module.exports = "../img/weber-2wftNjp.svg";